// admin/src/hooks/useProfile.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { profileService } from '../services/profile';

// Query keys
const QUERY_KEYS = {
  profile: ['profile']
};

// Get admin profile
export const useProfile = () => {
  return useQuery({
    queryKey: QUERY_KEYS.profile,
    queryFn: profileService.getProfile,
    onError: (error) => {
      toast.error('Erreur lors du chargement du profil');
      console.error('Profile fetch error:', error);
    }
  });
};

// Update profile
export const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: profileService.updateProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.profile });
      toast.success('Profil mis à jour avec succès');
    },
    onError: (error) => {
      const message = error.response?.data?.message || 'Erreur lors de la mise à jour du profil';
      toast.error(message);
      console.error('Update profile error:', error);
    }
  });
};

// Change password
export const useChangePassword = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: profileService.changePassword,
    onSuccess: () => {
      toast.success('Mot de passe modifié avec succès');
    },
    onError: (error) => {
      const message = error.response?.data?.message || 'Erreur lors du changement de mot de passe';
      toast.error(message);
      console.error('Change password error:', error);
    }
  });
};